import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { useDeleteConfirmation } from "../../components/common";
import { NXEditPen, NXDelete } from "../../icons";
import useApi from "../../api";
import { fetchProductTypes } from "../../redux/productTypesSlice";
import { boolIndicator } from "../../utils";
import GenericSelectableTable from "../../components/selectableTable";



function ProductTypeTable({ getProductType, onModalOpen }: { getProductType: any, onModalOpen: (editId?: number) => void }) {

  const dispatch = useDispatch();
  const api = useApi();
  const productTypes = useSelector((state: RootState) => state.productTypes);

  
  const { handleDelete } = useDeleteConfirmation();





  useEffect(() => {
    if (!productTypes.results.length) {
      dispatch(fetchProductTypes() as any);
    }
  }, [dispatch, productTypes.results.length]);

  // Define table columns
  const columns = [
    {
      header: "ID",
      key: "id",
      render: (item: any) => (
        <p className="text-sm font-normal text-base-300 mt-1">#ID{item.id}</p>
      ),
    },
    { header: "Name", key: "name" },
    {
      header: "Taxable",
      key: "taxable",
      render: (item: any) => boolIndicator(item.taxable),
    },
    {
      header: "Has Variant",
      key: "has_variant",
      render: (item: any) => boolIndicator(item.has_variant),
    },
    {
      header: "Physical Product",
      key: "physical_product",
      render: (item: any) => (
        <>
          {boolIndicator(item.physical_product)} <span>{item.weight_unit}</span>
        </>
      ),
    },
    {
      header: "Track Stocks",
      key: "track_stock",
      render: (item: any) => boolIndicator(item.track_stock),
    },
    {
      header: "Actions",
      key: "actions",
      render: (item: any) => (
        <div className="flex gap-2">
          <button
            className="p-1"
            onClick={() => {
              handleDelete(item.id, "Product Type", api.deleteProductType, getProductType);
            }}
          >
            <NXDelete />
          </button>
          <button className="p-1" onClick={() => onModalOpen(item.id)}>
            <NXEditPen />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
        <div className="relative overflow-x-auto">
          <GenericSelectableTable
            columns={columns}
            data={productTypes.results}
          />
        </div>
    </>
  );
}

export default ProductTypeTable;
